/* eslint-disable no-restricted-globals */
import { useEffect, useState } from 'react';
import { logger, METRIC_NAME, DIMENSION_NAME } from '@amzn/atoz-shiftapp-metrics';
import { NavigationStartToCriticalFeature } from './navigationStartToCriticalFeature';
/**
 * Contains all metric logging that each page can utilize and share for consistency
 */
export var usePageMetrics = function (_a) {
    var pageName = _a.pageName, logCf = _a.logCf;
    var _b = useState(0), mountTime = _b[0], setMountTime = _b[1];
    var _c = useState(false), hasLoggedCf = _c[0], setHasLoggedCf = _c[1];
    /**
     * On mount:
     * 1. Logs page mount count metric
     * 2. Records the time (ms) that the mount ocurred
     */
    useEffect(function () {
        var _a;
        logger.emitCountMetric({
            metricName: METRIC_NAME.PAGE_MOUNT,
            dimensions: (_a = {},
                _a[DIMENSION_NAME.PAGE_NAME] = pageName,
                _a)
        });
        setMountTime(Date.now());
    }, []);
    /**
     * Logs the CF metric log based on the conditions set by the page
     */
    useEffect(function () {
        var _a;
        if (logCf && !hasLoggedCf) {
            var cfTime = Date.now();
            setHasLoggedCf(true);
            logger.emitLatencyMetric({
                metricName: METRIC_NAME.PAGE_REACT_MOUNT_TO_CRITICAL_FEATURE,
                metricValue: cfTime - mountTime,
                dimensions: (_a = {},
                    _a[DIMENSION_NAME.PAGE_NAME] = pageName,
                    _a)
            });
            NavigationStartToCriticalFeature.log(pageName);
        }
    }, [logCf]);
};
